export const LIST_VACAS = 'LIST_VACAS'
export const GET_VACA = 'GET_VACA'
